import { useState } from "react";

import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import PasswordStrengthBar from "react-password-strength-bar";

type Props = {
  accessor: string;
  label: string;
  getFieldProps: any;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  showStrengthBar?: boolean;
};

const PasswordField = ({
  accessor,
  label,
  getFieldProps,
  touched,
  errors,
  isSubmitting,
  showStrengthBar = true,
}: Props) => {
  const [show, setShow] = useState<boolean>(false);
  const handleClick = () => setShow(!show);

  const password = getFieldProps(accessor).value;

  return (
    <FormControl
      id={accessor}
      isInvalid={
        !!touched[accessor! as string] && !!errors[accessor! as string]
      }
    >
      <FormLabel fontSize={"sm"} htmlFor={accessor! as string}>
        {label}
      </FormLabel>

      <InputGroup>
        <Input
          fontSize={"md"}
          variant={"outline"}
          autoComplete="new-password"
          placeholder={`${label}...`}
          isDisabled={isSubmitting}
          {...getFieldProps(accessor)}
          pr="4.5rem"
          type={show ? "text" : "password"}
        />
        <InputRightElement width="4.5rem">
          <Button size="xs" onClick={handleClick}>
            {show ? "Hide" : "Show"}
          </Button>
        </InputRightElement>
      </InputGroup>

      <FormErrorMessage>{errors[accessor! as string]}</FormErrorMessage>

      {showStrengthBar && +password?.length > 0 ? (
        <PasswordStrengthBar minLength={8} password={password} />
      ) : (
        <></>
      )}
    </FormControl>
  );
};

export default PasswordField;
